import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

export const selectIngestManagement = (state: RootState) => state.ingestManagement || {};
export const selectIngestManagementRecentTitles = createSelector([selectIngestManagement], (ingestManagement) => ingestManagement.recentTitles);
export const selectIngestManagementSelectedTitles = createSelector([selectIngestManagement], (ingestManagement) => ingestManagement.selectedTitles);
export const selectIngestManagementSelectedRecentTitles = createSelector(
  [selectIngestManagement],
  (ingestManagement) => ingestManagement.selectedRecentTitles
);
export const selectIngestManagementRegisterAgainst = createSelector([selectIngestManagement], (ingestManagement) => ingestManagement.registerAgainst);
